/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import AgGrid from 'DesignSystem/AgGrid/react'
import CloseAction from './CloseAction/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/New/TreatmentCard/Events/Content/Content/Events/Content/Compact/Past/Content/Content/NotesHeader/Notes/Content",
  columnDefs,
  rowData,
  isFullWidthRow,
  fullWidthCellRenderer
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let patientPersonValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'person',
})
let treatmentCardNameValueData = fromData.useDataValue({ viewPath,
context: 'treatment_card',
path: 'name',
})
let aggregateData = fromHelpers.getTitle(patientPersonValueData, treatmentCardNameValueData)
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 width="90%"
 height="90%"
 dangerouslyBypassFocusLock={true}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--mb-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginTop={0}
 level="h2"
 data="patient.person"
 data="treatment_card.name"
 aggregate="helpers.js getTitle"
 text={aggregateData}
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
</div>
<AgGrid
{...childProps}
  viewPath={`${viewPath}/AgGrid`}
 height="100%"
 headerHeight={30}
 rowGroupPanelShow="never"
 verticalBorders={true}
 scrollToEnd={true}
 overlayNoRowsTemplate="No past appointments found"
 columnDefs={columnDefs}
 rowData={rowData}
 isFullWidthRow={isFullWidthRow}
 fullWidthCellRenderer={fullWidthCellRenderer}
/>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}